import { PureComponent } from 'react';
import { Trans } from 'react-i18next';
import { Container, Col, Row } from 'react-bootstrap';
import { Field } from '@enterprise/common';
import { SpotRadio, SpotHorizontalFields, SpotRadioGroup } from '@enterprise/spot';
import styles from './pricingEditFormFieldset.module.scss';

interface StatusEditFormFieldsetProps {}

export class StatusEditFormFieldset extends PureComponent<StatusEditFormFieldsetProps> {
    render() {
        const {} = this.props;
        return (
            <Container fluid={true}>
                <Row>
                    <Col xs={12}>
                        <SpotHorizontalFields className={styles.horizontalFields}>
                            <SpotRadioGroup title={'Status'}>
                                <Field name="isActive" type="radio" value={true}>
                                    {({ input }) => (
                                        <SpotRadio {...input}>
                                            <Trans key="editPricing:active">Active</Trans>
                                        </SpotRadio>
                                    )}
                                </Field>
                                <Field name="isActive" type="radio" value={false}>
                                    {({ input }) => (
                                        <SpotRadio {...input}>
                                            <Trans key="editPricing:inactive">Inactive</Trans>
                                        </SpotRadio>
                                    )}
                                </Field>
                            </SpotRadioGroup>
                        </SpotHorizontalFields>
                    </Col>
                </Row>
            </Container>
        );
    }
}
